//
import PosLastSalesModel from '@/models/POS/PosLastSales'

/**
 * 
 */
export default class PosLastSalesService {

  /**
   * Get default response.
   */
  static getAllDefault() {
    return Promise.resolve({
      "current_page": 1,
      "data": [
        {
          "id": 62036,
          "typeId": 2,
          "type": "Factura",
          "statusId": 19,
          "status": "Realizada",
          "folio": "793944",
          "createdAt": "2020-01-11 10:12:00",
          // PUEDE SER NULL
          "customer": {
            "id": 10422,
            "rut": "78578870-2",
            "name": "COMERCIAL SUD TIROL LTDA.",
            "business_name": "COMERCIAL SUD TIROL LTDA.",
            "core_business_id": 712,
            "core_business": "FABRICACION DE POSTRES A BASE DE LECHE (HELADOS, SORBETES Y OTROS SIMILARES)",
            "branch_office_id": 10497,
            "branch_office": "GABRIEL GONZALEZ VIDELA 1900, La Serena",
            "branch_office_phone": "212273",
            "branch_office_email": "clientesagro@yopmail.com"
          },
          // PUEDE SER NULL
          "dispatchRequest": {
            "id": 728,
            "status_id": 39,
            "status": "Anulado en Inventario"
          },
          "total": 18020,
          "details": [
            {
              "line_number": 1,
              "name": "CLAVO DE OLOR MOLIDO 1 KG",
              "alias": "CLAVO1",
              "price": 18490,
              "quantity": 5,
              "total": 92450
            },
            {
              "line_number": 2,
              "name": "CANELA MOLIDA 1 KG",
              "alias": "CANELA1",
              "price": 10090.12,
              "quantity": 5.23,
              "total": 50450
            }
          ]
        }
      ],
      "first_page_url": "http://localhost:8000/api/pos_last_sales?page=1",
      "from": 1,
      "last_page": 1,
      "last_page_url": "http://localhost:8000/api/pos_last_sales?page=1",
      "next_page_url": null,
      "path": "http://localhost:8000/api/pos_last_sales",
      "per_page": 10,
      "prev_page_url": null,
      "to": 1,
      "total": 1
    })
  }
  
  /**
   * Get all results
   */
  static getAll() {
    return this
      .model()
      .limit(-1)
      .get()
  }

  /**
   * Get last pos sales by customer and branch office
   * @param {*} customerId 
   * @param {*} customerBranchOfficeId 
   */
  static getLastByCustomerAndBranchOffice(customerId, customerBranchOfficeId) {
    return this
    .model()
    .where('sl_customer_id', customerId)
    .where('sl_customer_branch_offices_id', customerBranchOfficeId)
    .limit(15)
    .page(1)
    .get()
  }
  
  /**
   * Get all pos sales by dates
   * @param {*} createdAtMax 
   * @param {*} createdAtMin 
   */
  static getAllByDates(createdAtMax, createdAtMin) {
    return this
      .model()
      .where('created_at_max', createdAtMax)
      .where('created_at_min', createdAtMin)
      .limit(-1)
      .get()
  }
  
  /**
   * Define the service model
   */
  static model() {
    return PosLastSalesModel
  }
}